var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLv3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 140,
    viewBox: "0 0 165 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LV3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M123.702 66.2H126.022C129.062 66.2 131.435 65.4267 133.142 63.88C134.902 62.28 135.782 59.7467 135.782 56.28C135.782 53.24 135.062 50.9733 133.622 49.48C132.235 47.9333 130.235 47.16 127.622 47.16C127.409 47.16 127.169 47.16 126.902 47.16C126.635 47.16 126.369 47.1867 126.102 47.24L125.302 52.44C124.982 54.4667 124.262 55.9067 123.142 56.76C122.075 57.56 120.822 57.96 119.382 57.96C117.355 57.96 115.862 57.1067 114.902 55.4C115.062 52.4667 115.862 50.0933 117.302 48.28C118.795 46.4667 120.715 45.1333 123.062 44.28C125.462 43.4267 128.022 43 130.742 43C136.662 43 141.062 44.2267 143.942 46.68C146.875 49.1333 148.342 52.1733 148.342 55.8C148.342 58.3067 147.462 60.7067 145.702 63C143.942 65.2933 141.035 66.9733 136.982 68.04C141.675 68.8933 144.982 70.4667 146.902 72.76C148.875 75 149.862 77.8533 149.862 81.32C149.862 84.0933 149.062 86.6 147.462 88.84C145.915 91.0267 143.649 92.76 140.662 94.04C137.729 95.2667 134.155 95.88 129.942 95.88C124.395 95.88 120.155 94.7333 117.222 92.44C114.289 90.1467 112.715 86.8933 112.502 82.68C112.982 81.4 113.675 80.4933 114.582 79.96C115.542 79.3733 116.502 79.08 117.462 79.08C119.115 79.08 120.422 79.5867 121.382 80.6C122.342 81.6133 123.009 83.48 123.382 86.2L124.102 91.56C124.422 91.6133 124.715 91.6667 124.982 91.72C125.302 91.72 125.622 91.72 125.942 91.72C133.142 91.72 136.742 88.12 136.742 80.92C136.742 77.6133 135.862 75.08 134.102 73.32C132.342 71.56 129.809 70.68 126.502 70.68H123.702V66.2Z",
    fill: "url(#paint0_linear_240_2116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M91.6106 47.08V43H108.971V47.32L102.971 48.28L86.4906 95.72H78.7306L61.5306 47.8L56.8906 47.32V43H82.6506V47.08L75.8506 47.96L86.8106 80.92L97.8506 48.12L91.6106 47.08Z",
    fill: "url(#paint1_linear_240_2116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21 47.32V43H47.4V47.32L40.76 47.96C40.7067 51.2133 40.6533 54.52 40.6 57.88C40.6 61.1867 40.6 64.4933 40.6 67.8V72.04C40.6 74.92 40.6 77.9867 40.6 81.24C40.6533 84.44 40.7067 87.6933 40.76 91H54.6L56.76 79.88H63.24L62.44 95.56H21V91.24L27 90.6C27.1067 87.3467 27.16 84.1733 27.16 81.08C27.16 77.9333 27.16 75.0533 27.16 72.44V67.8C27.16 64.4933 27.16 61.1867 27.16 57.88C27.16 54.52 27.1067 51.2133 27 47.96L21 47.32Z",
    fill: "url(#paint2_linear_240_2116)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_2116",
    x1: 18.3607,
    y1: 71.68,
    x2: 153.361,
    y2: 71.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F7DBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DBB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_240_2116",
    x1: 18.36,
    y1: 72.56,
    x2: 153.36,
    y2: 72.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F7DBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DBB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_240_2116",
    x1: 18.36,
    y1: 72.56,
    x2: 153.36,
    y2: 72.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F7DBB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E8B87F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DBB9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLv3);
export default __webpack_public_path__ + "static/media/lv3.50919f9c5b05c039cd3e50fe82ba72d5.svg";
export { ForwardRef as ReactComponent };